import { atomWithStorage } from 'jotai/utils';

export const screenerAllFacilitiesSelectedLastValueAtom =
  atomWithStorage<boolean>('screenerAllFacilitiesSelectedLastValue', false);
